export default __webpack_public_path__ + "static/media/1.fb7e5e06.mp4";